<template>
    <div>
        <div class="schedules-title">安全日志配置</div> 
        <!-- 安全日志 -->
        <Form ref="instanceRecoveryForm" :model="instanceRecoveryForm" :rules="ruleValidate" :label-width="120">
            <Row style="margin-bottom: 20px;">
                <Col span="24">
                    <Card >
                        <Row style="margin-top: 15px;">
                            <FormItem label="安全日志保留时间" prop="saveTime">
                                 <Select v-model="instanceRecoveryForm.saveTime" :transfer="true" style="width:300px;">
                                    <Option :value="item.id" v-for="(item,index) in saveTimeList" v-bind:key="index">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Row>
                        <Row>
                            <FormItem>
                                <Checkbox v-model="instanceRecoveryForm.disclaimer" @on-change="changeDisclaimer">阅读并同意</Checkbox>
                                <a @click="modal1 = true">《免责条款》</a>                                
                            </FormItem>
                        </Row>
                        <Modal v-model="modal1" title="免责条款" width="700px">
                            <h3>1.Cloudtrail优势</h3>
                            <p style="text-indent: 10px;">AWS CloudTrail 是一项服务，支持对贵公司 AWS 账户进行监管、合规性检查、操作审核和风险审核。借助 CloudTrail，贵公司可以记录日志、持续监控并保留与整个 AWS 基础设施中的 API 调用相关的事件。CloudTrail 可提供贵公司账户的 AWS API 调用历史记录，包括通过 AWS 管理控制台、AWS 开发工具包、命令行工具和其他 AWS 服务执行的 API 调用。此历史记录可简化安全性分析、资源更改跟踪和故障排除。
                            </p>
                            <p style="text-indent: 10px;">作为一项AWS重要的安全管理工具。Cloudtrail具有很多自身的优势：
                                <ul>
                                    <li style="padding-left: 20px;">简化的合规性</li>
                                    <li style="padding-left: 20px;">用户与资源活动的可见性</li>
                                    <li style="padding-left: 20px;">安全性分析和故障排除</li>
                                    <li style="padding-left: 20px;">安全自动化</li>
                                </ul>
                            </p>
                            <br>
                            <h3>2.Silver Lining 的Cloudtrail政策</h3>
                            <p style="text-indent: 10px;">对于进入Silver Lining运维流程的客户，我们的工程师会在第一时间联系客户，对客户账户和资源进行初始化审查和安全配置操作，包括御云者账户的绑定、安全审查，TAG规范等。作为初始化的重要部分，Cloudtrail是我们要求客户要打开的功能。对于不愿意开启Cloudtrail功能的客户，我们会提供相关的免责条款，详细请参考第三部分《免责条款》
                            </p>
                            <br>
                            <h3>3.免责条款</h3>
                            <p style="text-indent: 10px;">为更好的管理贵公司的AWS账户及其资源，保障安全性，Silver Lining建议贵公司开启AWS Cloudtrail功能。如果贵公司自主放弃使用此功能，表示贵公司明白且同意签署以下免责条款协议（以下简称“本协议”），请贵公司务必仔细阅读并遵守。</p>
                            <br>
                            <h4>一、【本协议的范围】</h4>
                            <p style="text-indent: 10px;">1.1【本协议适用主体范围】</p>
                            <p style="text-indent: 10px;">本协议是贵公司与Silver Lining之间，关于贵公司拒绝开启CloudTrail功能所订立的协议。</p>
                            <br>
                            <h4>二、【关于本协议】</h4>
                            <p style="text-indent: 10px;">2.1【本协议目的】</p>
                            <p style="text-indent: 10px;">本协议目的是明确由于贵公司拒绝开启CloudTrail功能服务，因此Silver Lining运维服务内容将不包括Cloudtrail及其相关功能，贵公司也不会因此向Silver Lining 究责。</p>
                            <p style="text-indent: 10px;">2.2【本协议内容】</p>
                            <p style="text-indent: 10px;">签署本协议，表示贵公司完全了解拒绝开启CloudTrail服务可能对贵公司AWS账户管理及其安全审计所造成的影响（包括但不限于）：</p>
                            <p style="text-indent: 10px;">
                                <ul>
                                    <li style="padding-left: 20px;">1.无法对整个AWS账户已执行操作的活动日志进行记录和存储；</li>
                                    <li style="padding-left: 20px;">2.无法记录 AWS API 调用信息，包括 AWS 的用户和账户、发起调用的源 IP 地址以及执行调用的时间；</li>
                                    <li style="padding-left: 20px;">3.捕捉特定时段内贵公司的 AWS 账户中所发生更改的全面历史记录，发现并解决安全性和操作性问题；</li>
                                    <li style="padding-left: 20px;">4.无法跟踪并自动应对威胁 AWS 资源安全性的 API 活动。</li>
                                </ul>
                            </p>
                            <p style="text-indent: 10px;">2.3 【本协议范围】</p>
                            <p style="text-indent: 10px;">与Cloudtrail相关问题或者需要借助Cloudtrail服务来解决的问题。</p>
                            <br>
                            <h4>三、【本协议效力】</h4>
                            <p style="text-indent: 10px;">3.1签署本协议，表示贵公司自主放弃使用AWS Cloudtrail服务；</p>
                            <p style="text-indent: 10px;">3.2若贵公司在后期使用AWS过程中，遇到Cloudtrail相关问题或者需要借助Cloudtrail服务来解决的问题，则不在Silver Lining支持的范围内。</p>
                            <p style="text-indent: 10px;">3.3由于拒绝开启Cloudtrail所造成的相关安全以及审计问题，将由贵公司自行承担，Silver Lining将不承担任何责任。</p>
                            <br>
                            <h4>四、【其他】</h4>
                            <p style="text-indent: 10px;">4.1本协议签订地为中华人民共和国上海市。</p>
                            <p style="text-indent: 10px;">4.2本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</p>
                            <p style="text-indent: 10px;">4.3若贵公司和Silver Lining之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。</p>
                            <p style="text-indent: 10px;">4.4本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</p>
                            <p style="text-indent: 10px;">4.5若本协议有中文、英文等多个语言版本，相应内容不一致的，均以中文版的内容为准。</p>
                            <div slot="footer"></div>
                        </Modal>
                        <Row>
                            <Button type="primary" style="float: right;" @click="configuration('instanceRecoveryForm')" :disabled="isDisable" v-hasPermission="['configurationManagement:securityLogConfiguration:configure']">配置</Button>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </Form>
    </div>
</template>

<script>
    import {setCookie,getCookie,delCookie} from '../../../../utils/cookieUtil.js'
    export default {
        name: 'Schedules',
        data () {
            return {
                id:'',
                isDisable: true,
                modal1: false,
                instanceRecoveryForm:{
                    saveTime:'',
                    disclaimer: false
                },
                saveTimeList:[{
                    id:30,
                    name:'一个月'
                },{
                    id:60,
                    name:'二个月'
                },{
                    id:90,
                    name:'三个月'
                }],
                ruleValidate: {
                    saveTime: [
                        { required: true, message: '请选择安全日志保留时间', trigger: 'change',type:'number'  }
                    ]
                }
            }
        },
        mounted: function(){
            this.query();
        },
        methods: {
            query:function(){
                this.$api.resourceSecurityLogConfiguration.query({})
                .then(res => {
                    this.instanceRecoveryForm.disclaimer=res.data.agree;
                    this.instanceRecoveryForm.saveTime=res.data.keepTime;
                    this.id=res.data.id;
                    setCookie('securityLogRetentionTime', this.instanceRecoveryForm.saveTime);
                    if(this.instanceRecoveryForm.disclaimer==true){
                        this.isDisable = false; 
                    }else if(this.instanceRecoveryForm.disclaimer==false){
                        this.isDisable = true;
                    }
                })
            },
            // 切换免责条款
            changeDisclaimer:function(){
                if(this.instanceRecoveryForm.disclaimer==true){
                    this.isDisable = false; 
                }else if(this.instanceRecoveryForm.disclaimer==false){
                    this.isDisable = true;
                }
            },
            // 配置
            configuration:function(name){
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        var configurationData={
                            "keepTime":this.instanceRecoveryForm.saveTime,
                            "isAgree":this.instanceRecoveryForm.disclaimer
                        };
                        if(this.id){
                            configurationData.id=this.id;
                        }
                        this.$api.resourceSecurityLogConfiguration.configuration(configurationData)
                        .then(res => {
                            this.query();
                            this.$Message.success('配置成功');
                        })                        
                    }
                })                
            }
        }
    }
</script>

<style scoped>
    .schedules-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 15px 4px;
        font-weight: 600;
    }
    .title
    {
        font-size:14px;
        font-weight: 600;
        float:left;
        color:#000;
        margin-bottom: 30px;
    }
</style>







// WEBPACK FOOTER //
// src/components/configuration/configuration_management/security_log_configuration/SecurityLogConfiguration.vue